(function () {
  var storageKey = 'tr_paid_attribution_v1';
  var trackedParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'fbclid',
    'gclid',
    'msclkid'
  ];

  function readState() {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function writeState(state) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {
      return;
    }
  }

  function cleanValue(value, maxLength) {
    if (!value) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, maxLength || 220);
  }

  function currentTouch() {
    var params = new URLSearchParams(window.location.search);
    var touch = {
      landing_page: cleanValue(window.location.href, 500),
      referrer: cleanValue(document.referrer, 500),
      captured_at: new Date().toISOString()
    };
    var hasSignal = false;

    trackedParams.forEach(function (name) {
      var value = params.get(name);
      if (value) {
        touch[name] = cleanValue(value, 220);
        hasSignal = true;
      }
    });

    return hasSignal ? touch : null;
  }

  function buildAttributes(state) {
    var first = state.first_touch || {};
    var last = state.last_touch || first;
    var attrs = {};

    [
      ['tr_first_utm_source', first.utm_source],
      ['tr_first_utm_medium', first.utm_medium],
      ['tr_first_utm_campaign', first.utm_campaign],
      ['tr_first_utm_content', first.utm_content],
      ['tr_first_landing_page', first.landing_page],
      ['tr_first_referrer', first.referrer],
      ['tr_first_captured_at', first.captured_at],
      ['tr_last_utm_source', last.utm_source],
      ['tr_last_utm_medium', last.utm_medium],
      ['tr_last_utm_campaign', last.utm_campaign],
      ['tr_last_utm_content', last.utm_content],
      ['tr_last_utm_term', last.utm_term],
      ['tr_last_utm_id', last.utm_id],
      ['tr_last_fbclid', last.fbclid],
      ['tr_last_gclid', last.gclid],
      ['tr_last_msclkid', last.msclkid],
      ['tr_last_landing_page', last.landing_page],
      ['tr_last_referrer', last.referrer],
      ['tr_last_captured_at', last.captured_at]
    ].forEach(function (pair) {
      if (pair[1]) attrs[pair[0]] = cleanValue(pair[1], 500);
    });

    if (last.fbclid && !attrs.tr_last_utm_source) {
      attrs.tr_last_paid_signal = 'meta_fbclid';
    }

    return attrs;
  }

  function sameAttributes(a, b) {
    return JSON.stringify(a || {}) === JSON.stringify(b || {});
  }

  function persistCartAttributes(attrs) {
    if (!Object.keys(attrs).length || sameAttributes(attrs, window.__trPaidAttributionLastSync)) return Promise.resolve();
    window.__trPaidAttributionLastSync = attrs;

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {
      window.__trPaidAttributionLastSync = null;
    });
  }

  function captureAndPersist() {
    var state = readState();
    var touch = currentTouch();

    if (touch) {
      if (!state.first_touch) state.first_touch = touch;
      state.last_touch = touch;
      writeState(state);
    }

    return persistCartAttributes(buildAttributes(state));
  }

  captureAndPersist();

  document.addEventListener(
    'submit',
    function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('form[action*="/cart"], form[action*="/checkout"]')) return;
      captureAndPersist();
    },
    true
  );

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('button[name="add"], button[name="checkout"], a[href*="/checkout"]') : null;
    if (target) captureAndPersist();
  });
})();
